enum UserRole {
  STUDENT = 'STUDENT',
  COACH = 'COACH',
  EDITOR = 'EDITOR',
  ADMIN = 'ADMIN',
  SUPER_ADMIN = 'SUPER_ADMIN',
}

export default UserRole;
